import React, { useEffect, useContext } from "react";
import { fetchCollectionAction } from "state/actions/collectionActions";
import { MY_VOUCHER } from "state/constants/actions";
import { useDispatch, useSelector } from "react-redux";
import { requestMyVoucher } from "apis/myvoucher";
import AccountMyVoucher from "../components/AccountMyVoucher";
import { getUserVoucers } from "../apis/middlewareEndpoints";
import { useAuth0 } from "@auth0/auth0-react";

const MyVoucher = ({ ...props }) => {
  const { collection: my_voucher, uiState, error } = useSelector(
    (state) => state.my_voucher
  );
  const dispatch = useDispatch();
  useEffect(() => {
    if (process.env.GATSBY_ENABLE_AUTH0 !== "true") {
      fetchCollectionAction(MY_VOUCHER, dispatch, requestMyVoucher, {
        lang: props.langKey,
      });
    }
  }, []);
  const { isAuthenticated, getAccessTokenSilently } = useAuth0();
  useEffect(() => {
    if (process.env.GATSBY_ENABLE_AUTH0 === "true") {
      if (isAuthenticated) {
        const getMemberVoucers = async () => {
          const token = await getAccessTokenSilently();

          fetchCollectionAction(MY_VOUCHER, dispatch, getUserVoucers, {
            token,
          });
        };

        getMemberVoucers();
      }
    }
  }, [isAuthenticated, getAccessTokenSilently]);

  return (
    <AccountMyVoucher
      data={my_voucher}
      langData={props.langData}
      uiState={uiState}
      locale={props.locale}
    />
  );
};

export default MyVoucher;
